import gql from 'graphql-tag';

const DELETE_TEAM = gql`
  mutation deleteTeam($where: TeamWhereUniqueInput!) {
    deleteTeam(where: $where) {
      id
      name
    }
  }
`;

export default DELETE_TEAM;
